import { AppState } from 'Store'

const getAllProject = (state: AppState) => state.knowledge.project.data
const getOneProject = (state: AppState) => state.knowledge.project.project
const getProjectRequestParams = (state: AppState) => state.knowledge.project.requestParams

export const projectSelector = {
	getAllProject,
	getOneProject,
	getProjectRequestParams,
}
